import * as React from "react";
import { type FC } from "react";

import { Button } from "../../Action/Button/Button";

interface CreateBlockButtonProps {
    label: string;
    onClick: () => void;
}

export const CreateBlockButton: FC<CreateBlockButtonProps> = ({ label, onClick }) => (
    <Button use={"link"} icon={"PlusIcon"} value={label} onClick={onClick} />
);
